<i class="mi mi-close float-end d-inline dialog-close" mat-dialog-close></i>
<h4 class="">Manage Linked Accounts</h4>
<mat-chip-list class="mat-chip-list-stacked" #chipList aria-label="linkedAccount selection">
  <input
    class="mat-chip-input"
      placeholder="{{ 'pages.placeholders.EnterBusinessname' | translate }}..."
      #linkedAccountInput
      [formControl]="linkedAccountCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />  
  <mat-chip
      *ngFor="let linkedAccount of currentLinkedRetailers"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(linkedAccount)">
      {{linkedAccount.businessName}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let linkedAccount of filteredlinkedAccounts" [value]="linkedAccount">
      {{linkedAccount.businessName}}
    </mat-option>
  </mat-autocomplete>